export default __webpack_public_path__ + "static/media/hm.97435dd8.svg";